<div class="flex flex-col overflow-y-auto max-h-full">
  @for (p of availableProducts(); track p.name) {
  <button (click)="setActiveReport(p.name)" type="button"
    class="flex flex-col items-center justify-center rounded-r-none! w-full px-1 btn-ghost cursor-pointer py-1 text-base-100/85 hover:bg-base-100/5 hover:border-r-primary/50  border-r-transparent border-r-4"
    [class.active-button]="p.name === activeReport()?.name">
    <span class="material-symbols-outlined">{{ p.material_icon }}</span>
    <span class="text-[0.5rem] font-thin text-base-content/25 truncate">
      {{ p.name }}
    </span>
  </button> }
</div>